// BR 巴西逻辑

import vueI18n from '@/i18n/locale'
import caculateWidthBy10FontSize from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/caculateFontSize.js'
import {
  getMaxValue,
  getMaxLengthValue,
  isSmallScreenMobile,
} from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/utils.js'
import {
  LegendBuilder,
  XAxisBuilder,
  YAxisBuilder,
  WeekendBuilder,
  ToolTipBuilder,
  getAdaptiveBarWidthByCount,
  getEchartHeightAndBottomByLocale,
} from '../builderBR.js'

const investEchartConfig = getEchartHeightAndBottomByLocale('promotionInvest')
const promoEchartConfig = getEchartHeightAndBottomByLocale('promotionPromo')
const ICONWIDTH = 20
const ICONHEIGHT = 8

export const PROMOTION_INVEST_LEGEND_ITEMS = t => [
  {
    name: t('FoodB_2_R_Burn_AyGL' /** R burn/ GMV */),
    type: 'line',
    color: '#0D86FF',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('FoodB_list_B_Burn_LIiU' /** B2C burn / GMV */),
    type: 'line',
    color: '#85C2FF',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
]

export const PROMOTION_MARKETING_LEGEND_ITEMS = t => [
  {
    name: t('FoodB_0919__etPs' /** 多种类营销 */),
    type: 'bar',
    color: '#086ACC',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('Gattaran_opt_swMT_sNcV' /** 营销-套餐 */),
    type: 'bar',
    color: '#369AFF',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('Gattaran_opt_RltV_fDyM' /** 特价餐(非套餐） */),
    type: 'bar',
    color: '#85C2FF',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('FoodB_SMS__promotion_EKZy' /** 免配送 */),
    type: 'bar',
    color: '#D6EBFF',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('FoodB_optimization_Buy_gifts_daUI' /** 买赠 */),
    type: 'bar',
    color: '#189959',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('FoodB_optimization_Full_reduction_NlOa' /** 满减 */),
    type: 'bar',
    color: '#42C97B',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('FoodC_intostore_Store_Coupon_kHwh' /** 商家券 */),
    type: 'bar',
    color: '#87E0AC',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
  {
    name: t('FoodB_0919__YKYU' /** 非营销 */),
    type: 'bar',
    color: '#D5F5E2',
    iconWidth: ICONWIDTH,
    iconHeight: ICONHEIGHT,
  },
]

export default function transformer(data = {}, dateToWeek = {}, key = 'promotion', direction) {
  const { name, period, indicators } = data

  const verticalHeight = isSmallScreenMobile()
    ? investEchartConfig.height // 小屏（竖屏）
    : investEchartConfig.height
  const horizontalHeight = isSmallScreenMobile()
    ? investEchartConfig.heightHor // 小屏（横屏）
    : investEchartConfig.heightHor
  const chartHeight = direction === 'vertical' ? verticalHeight : horizontalHeight

  return {
    title: name,
    period,
    indicators,
    chartData: [
      parseInvestChartsData(data.chartData, dateToWeek, direction), // 投资
      parsePromoChartsData(data.chartData, dateToWeek, direction), // 营销
    ],
    chartHeight,
    chartkey: key,
  }
}

function parseInvestChartsData(chartData = {}, dateToWeek, direction) {
  const {
    rBurnRatio = [], // BBurn
    bBurnRatio = [], // RBurn
  } = chartData || {}
  const maxRadio = getMaxLengthValue({ radio: rBurnRatio.concat(bBurnRatio) })
  const xAxisData = rBurnRatio.map(item => item.date)
  // rate 折线率类型的图表计算左右间距
  // 小数点在 caculateWidthBy10FontSize 中会被当作普通字符按 6.4px 计算宽度，导致 grid.left 偏大
  // 向上取整消除小数点，保证宽度估算准确
  const maxRadioCeil = Math.ceil(maxRadio)
  const baseWidth = maxRadioCeil
    ? caculateWidthBy10FontSize(maxRadioCeil + '%')
    : caculateWidthBy10FontSize(0, 5)
  const left = baseWidth + 10
  return {
    grid: {
      top: 26,
      left,
      right: 8,
      bottom: direction === 'vertical' ? investEchartConfig.bottom : investEchartConfig.bottomHor,
    },
    tooltip: ToolTipBuilder({ isPromotionInvest: true }),
    legend: LegendBuilder(
      [
        {
          name: vueI18n.t('FoodB_2_R_Burn_AyGL' /** R burn/ GMV */),
          icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
        },
        {
          name: vueI18n.t('FoodB_list_B_Burn_LIiU' /** B2C burn / GMV */),
          icon: 'path://M960 470.857143H64c-5.028571 0-9.142857 4.114286-9.142857 9.142857v64c0 5.028571 4.114286 9.142857 9.142857 9.142857h896c5.028571 0 9.142857-4.114286 9.142857-9.142857v-64c0-5.028571-4.114286-9.142857-9.142857-9.142857z',
        },
      ],
      { show: false },
    ),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: '',
        // 暂优化掉标题：
        // vueI18n.t('FoodB_2_R_Burn_AyGL' /** R burn/ GMV */) + '/' + vueI18n.t('FoodB_list_B_Burn_LIiU' /** B2C burn / GMV */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left],
        },
        axisLabel: {
          formatter: '{value}%',
          fontSize: 10,
          color: '#8D9099',
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_2_R_Burn_AyGL' /** R burn/ GMV */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 0,
        color: '#0D86FF',
        lineStyle: {
          width: 2,
        },
        emphasis: {
          itemStyle: {
            color: '#0D86FF',
          },
        },
        data: rBurnRatio.map(item => item.value ?? '--'),
      },
      {
        name: vueI18n.t('FoodB_list_B_Burn_LIiU' /** B2C burn / GMV */),
        type: 'line',
        showSymbol: false,
        yAxisIndex: 0,
        color: '#85C2FF',
        lineStyle: {
          width: 2,
        },
        emphasis: {
          itemStyle: {
            color: '#85C2FF',
          },
        },
        data: bBurnRatio.map(item => item.value ?? '--'),
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
    legendItems: PROMOTION_INVEST_LEGEND_ITEMS(vueI18n.t.bind(vueI18n)),
  }
}

function parsePromoChartsData(chartData = {}, dateToWeek, direction) {
  const {
    completeOrderCntNotAct = [], // 非营销完单量
    completeOrderCntTwoPlusAct = [], // 两种营销类型及以上完单量
    completeOrderCntOneActSpecialCombo = [], // 营销 - 套餐
    completeOrderCntOneActSpecialNonCombo = [], // 特价餐(非套餐）
    completeOrderCntOneActFreedelivery = [], // 单营销类型[免配送]完单量
    completeOrderCntOneActBuygift = [], // 单营销类型[买赠]完单量
    completeOrderCntOneActReduction = [], // 单营销类型[满减]完单量
    completeOrderCntOneActStorecoupon = [], // 单营销类型[商家券]完单量
  } = chartData || {}
  const max = getMaxValue(chartData, ['rBurnRatio', 'bBurnRatio', 'cBurnRatio'])
  const legendItems = [
    vueI18n.t('FoodB_0919__etPs' /** 多种类营销 */),
    vueI18n.t('Gattaran_opt_swMT_sNcV' /** 营销-套餐 */),
    vueI18n.t('Gattaran_opt_RltV_fDyM' /** 特价餐(非套餐） */),
    vueI18n.t('FoodB_SMS__promotion_EKZy' /** 免配送 */),
    vueI18n.t('FoodB_optimization_Buy_gifts_daUI' /** 买赠 */),
    vueI18n.t('FoodB_optimization_Full_reduction_NlOa' /** 满减 */),
    vueI18n.t('FoodC_intostore_Store_Coupon_kHwh' /** 商家券 */),
    vueI18n.t('FoodB_0919__YKYU' /** 非营销 */),
  ]

  const xAxisData = completeOrderCntNotAct.map(item => item.date)
  const barWidth = getAdaptiveBarWidthByCount(xAxisData.length)
  const left = max ? caculateWidthBy10FontSize(max) + 10 : 16
  return {
    grid: {
      top: 26,
      left,
      right: 8,
      bottom: direction === 'vertical' ? promoEchartConfig.bottom : promoEchartConfig.bottomHor,
    },
    tooltip: ToolTipBuilder(),
    legend: LegendBuilder(legendItems, { show: false }),
    xAxis: XAxisBuilder({ data: xAxisData.map(item => item.substring(5)) }),
    yAxis: [
      YAxisBuilder({
        name: vueI18n.t('FoodB_APP_kvLF_MMXl' /** 日完单量 */),
        nameTextStyle: {
          color: '#8D9099',
          fontSize: 10,
          align: 'left',
          padding: [0, 0, 0, -left],
        },
      }),
    ],
    series: [
      {
        name: vueI18n.t('FoodB_0919__etPs' /** 多种类营销 */),
        type: 'bar',
        barWidth,
        color: '#086ACC',
        stack: 'promotion',
        data: completeOrderCntTwoPlusAct.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#086ACC' } },
      },
      {
        name: vueI18n.t('Gattaran_opt_swMT_sNcV' /** 营销-套餐 */),
        type: 'bar',
        barWidth,
        color: '#369AFF',
        stack: 'promotion',
        data: completeOrderCntOneActSpecialCombo.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#369AFF' } },
      },
      {
        name: vueI18n.t('Gattaran_opt_RltV_fDyM' /** 特价餐(非套餐） */),
        type: 'bar',
        barWidth,
        color: '#85C2FF',
        stack: 'promotion',
        data: completeOrderCntOneActSpecialNonCombo.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#85C2FF' } },
      },
      {
        name: vueI18n.t('FoodB_SMS__promotion_EKZy' /** 免配送 */),
        type: 'bar',
        barWidth,
        color: '#D6EBFF',
        stack: 'promotion',
        data: completeOrderCntOneActFreedelivery.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#D6EBFF' } },
      },
      {
        name: vueI18n.t('FoodB_optimization_Buy_gifts_daUI' /** 买赠 */),
        type: 'bar',
        barWidth,
        color: '#189959',
        stack: 'promotion',
        data: completeOrderCntOneActBuygift.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#189959' } },
      },
      {
        name: vueI18n.t('FoodB_optimization_Full_reduction_NlOa' /** 满减 */),
        type: 'bar',
        barWidth,
        color: '#42C97B',
        stack: 'promotion',
        data: completeOrderCntOneActReduction.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#42C97B' } },
      },
      {
        name: vueI18n.t('FoodC_intostore_Store_Coupon_kHwh' /** 商家券 */),
        type: 'bar',
        barWidth,
        color: '#87E0AC',
        stack: 'promotion',
        data: completeOrderCntOneActStorecoupon.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#87E0AC' } },
      },
      {
        name: vueI18n.t('FoodB_0919__YKYU' /** 非营销 */),
        type: 'bar',
        barWidth,
        color: '#D5F5E2',
        stack: 'promotion',
        data: completeOrderCntNotAct.map(item => item.value ?? '--'),
        emphasis: { itemStyle: { color: '#D5F5E2' } },
      },
      WeekendBuilder(xAxisData, dateToWeek),
    ],
    legendItems: PROMOTION_MARKETING_LEGEND_ITEMS(vueI18n.t.bind(vueI18n)),
  }
}
